export default "__VITE_ASSET__qNe0pUPG__"